import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Alcool au volant: Quelles conséquences sur les assurances automobile?"
            description="Vous avez récemment été reconnu coupable de conduite avec les facultés affaiblies? Avocats Alcool au Volant vous explique les conséquences sur votre prime d’assurance."
            fr={undefined}
            lawType="criminal"
            specialtyText="spécialisé en alcool au volant">
            <p>
                <strong>
                    En plus d’augmenter votre prime d’assurance, être reconnu
                    coupable d’alcool au volant, vous compliquez la vie.{' '}
                </strong>
            </p>
            <p>
                Votre permis pourrait être suspendu ou tout simplement révoqué.
                Dans ce cas, il ne vous sera tout simplement plus possible de
                conduire un véhicule.
            </p>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Mes assurances augmentent-ils en cas d’alcool au volant?"
                    alt=""
                />
            </p>
            <p>
                Dans les cas plus extrêmes, les assureurs pourraient décider de
                ne pas vous assurer, ce qui va également rendre la conduite d’un
                véhicule interdit.
            </p>
            <p>
                <strong>
                    Avocats alcool au volant vous explique les conséquences de
                    la conduite avec les facultés affaiblies sur votre
                    assurance!
                </strong>
            </p>
            <h2>Alcool au volant – Mon permis sera-t-il suspendu? </h2>
            <p>
                Dès que vous êtes arrêté par un policier et que ce dernier
                constate que vous avez conduit avec les facultés affaiblies (par
                l’alcool, les drogues ou les deux), votre permis sera
                automatiquement suspendu pour une{' '}
                <strong>durée d’au moins 3 mois</strong>.{' '}
            </p>
            <p>
                Ensuite, il faudra attendre le procès afin de savoir si votre
                permis sera suspendu pour une plus longue durée ou s’il sera
                tout simplement révoqué. Si le juge prononce une suspension du
                permis de la personne coupable d’alcool au volant, cette
                suspension peut durer entre 12 à 60 mois.
            </p>
            <p>
                Plusieurs facteurs vont permettre au juge de déterminer la durée
                de la suspension, notamment{' '}
                <Link to="https://avocatsalcoolauvolant.ca/recidive-alcool-volant/">
                    une récidive
                </Link>{' '}
                ou si le taux d’alcoolémie dépasse le double de la limite
                permise par la loi.{' '}
            </p>
            <p>
                <strong>Bon à savoir!</strong> Une infraction d’alcool au volant
                va apparaître pendant 10 ans dans votre dossier de conduite de
                la SAAQ.{' '}
            </p>
            <h2>
                Ai-je l’obligation de déclarer ma suspension de permis à mon
                assureur automobile?
            </h2>
            <p>
                Il sera nécessaire d’informer votre assureur automobile le plus
                rapidement possible lorsque l’une des situations suivantes
                survient:
            </p>
            <ul>
                <li>
                    Votre permis est suspendu en raison d’une arrestation pour
                    alcool au volant, ou
                </li>
                <li>
                    Vous êtes reconnu coupable de conduite avec les capacités
                    affaiblies et que votre permis est révoqué.
                </li>
            </ul>
            <p>
                De plus, si vous avez été{' '}
                <strong>condamné par le passé pour ivresse au volant</strong>,
                vous devrez le déclarer à votre nouvelle assurance automobile.
            </p>
            <p>
                <strong>
                    Que se passe-t-il si je ne dis rien à l’assureur auto?
                </strong>{' '}
                Les compagnies d’assurance peuvent vérifier votre dossier de
                conduite à même la Société de l’assurance automobile du Québec
                (SAAQ). Si votre passé refait surface, lors d’une réclamation
                par exemple, l’assureur pourrait pouvoir refuser de vous
                indemniser.
            </p>
            <p>
                L'assureur peut refuser de vous indemniser si vous avez fait une{' '}
                <strong>fausse déclaration</strong>, mais aussi s’il s’agit d’un
                oubli. Il est donc préférable d’être transparent dès les
                premiers instants.{' '}
            </p>
            <h2>
                Ma prime d’assurance va-t-elle augmenter si je perds mon permis?
            </h2>
            <p>
                Les primes d’assurance sont déterminées en fonction de plusieurs
                critères, dont le facteur de risque du conducteur. Être reconnu
                coupable de conduite avec les facultés affaiblies augmente
                clairement les risques.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Un assureur peut-il refuse de m’assurer en raison d’alcool au volant?"
                    alt=""
                />
            </p>
            <p>
                Par conséquent, être reconnu coupable de conduite avec les
                facultés affaiblies va augmenter votre prime d’assurance.
            </p>
            <p>
                Cependant, si vous êtes arrêté, mais que vous êtes reconnu non
                coupable, cela n’aura{' '}
                <strong>pas d’impact sur votre prime</strong>. Dans le cas d’une
                augmentation, le montant pourrait être important.
            </p>
            <p>
                Dans certains cas, les primes d’assurance vont même tripler.
                Toutefois, chaque assureur a ses barèmes et donc l’augmentation
                varie d’un assureur à l’autre. Il faudra aussi prendre en
                considération:
            </p>
            <ul>
                <li>L’âge du conducteur,</li>
                <li>Votre dossier, et </li>
                <li>Le degré de gravité de l’infraction. </li>
            </ul>
            <p>
                <strong>
                    Combien de temps dure l'augmentation de la prime?
                </strong>{' '}
                Il faut s’attendre à ce que la prime demeure élevée pour une
                durée entre 4 et 6 ans après votre infraction.{' '}
            </p>
            <h2>
                Dossier criminel – Est-ce tout de même possible d’être assuré?
            </h2>
            <p>
                Dès que vous êtes reconnu coupable de conduite avec les facultés
                affaiblies, vous aurez un <strong>dossier criminel</strong>.
                Lorsque vous pourrez conduire à nouveau, il faudra être assuré.{' '}
            </p>
            <ul>
                <li>
                    <strong>
                        Toutefois, trouver un assureur pourrait être plus
                        compliqué avec une condamnation pour alcool au volant.{' '}
                    </strong>
                </li>
            </ul>
            <p>
                En pratique, une seule condamnation ne va pas vous empêcher de
                trouver d’assureur. La prime risque toutefois d’être plus
                élevée. En revanche, après plusieurs condamnations, ou si vous
                avez causé un accident, certains assureurs pourraient refuser
                votre dossier.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Comment s’assurer avec un casier judiciaire?"
                    alt=""
                />
            </p>
            <p>
                Il faudra alors se tourner vers les assureurs spécialisés qui
                acceptent un plus gros niveau de risque. Le coût de la prime
                sera toutefois conséquent.
            </p>
            <p>
                <strong>
                    Accusé d’avoir conduit avec les facultés affaiblies? Avocats
                    alcool au volant vous permet de trouver un avocat pour vous
                    défendre!
                </strong>
            </p>
            <h2>Quels sont les autres coûts à prévoir?</h2>
            <p>
                Outre l’augmentation de votre prime d’assurance, il faudra
                également prendre en considération plusieurs autres frais
                associés avec une infraction de{' '}
                <Link to="https://avocatsalcoolauvolant.ca/avocat-conduite-facultes-affaiblies/">
                    conduite avec les facultés affaiblies.
                </Link>{' '}
            </p>
            <p>
                Tout d’abord, il faudra prévoir la contravention elle-même ainsi
                que les autres frais obligatoires. Ce montant sera d’au moins 2
                000$. Il faudra également inclure les coûts suivants:
            </p>
            <ul>
                <li>
                    Les frais du casier judiciaire, du greffe et des honoraires
                    d’avocat,
                </li>
                <li>Les frais de remorquage et de remisage,</li>
                <li>
                    Les frais de transport (lorsque votre permis est suspendu),{' '}
                </li>
                <li>
                    Les frais d’installation d’un antidémarreur, le cas échéant,
                    et{' '}
                </li>
                <li>
                    La contribution au régime d’indemnisation des victimes
                    d’actes criminels.
                </li>
            </ul>
            <p>
                Ainsi, la facture peut rapidement devenir élevée et les coûts
                seront importants. Il est donc préférable d’éviter l’alcool au
                volant et d’opter pour des{' '}
                <strong>alternatives sécuritaires</strong> (covoiturage,
                transport en commun...).
            </p>
            <h2>
                Problème avec vos assureurs en raison de l’alcool au volant?
                Avocats alcool au volant est là pour vous!
            </h2>
            <p>
                Il est possible que votre assureur vous mène la vie dure après
                avoir été reconnu coupable d’alcool au volant. Bien qu’il ait
                plusieurs droits, l’assureur n’a pas tous les pouvoirs non plus.{' '}
            </p>
            <p>
                Si vous êtes confronté à un assureur qui abuse de sa position,
                il est possible de faire appel à un avocat afin de recevoir
                l’aide nécessaire.
            </p>
            <p>
                <strong>
                    Heureusement, grâce au formulaire en ligne d’Avocats alcool
                    au volant, il vous sera possible de trouver le bon
                    professionnel gratuitement!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "consequence-prime-assurance/assurance-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "consequence-prime-assurance/refus-assurance-automobile.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "consequence-prime-assurance/assurance-casier-judiciaire.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
